export const SHARE_VIA_EMAIL_FORM = 'ShareViaEmailForm'
export const EMAIL_FIELD = 'email'
export const MESSAGE_FIELD = 'message'

export const UNKNOWN_ERROR = 'Something wrong happened. Please try later.'
export const MESSAGE_OF_SUCCESSFUL_SENDING = 'Your email has been sent.'
